
	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { BlogEntry, PagedResult } from '@shared/models';
	import AboutMenu from '@client/views/common/AboutMenu.vue';
	import TagCloud from '@client/views/blog/TagCloud.vue';
	import ContactWidget from '@client/views/common/ContactWidget.vue';

	@Component({
		components: {
			TagCloud,
			ContactWidget,
			AboutMenu,
		},
	})
	export default class BlogEntries extends BaseView {

		public list: PagedResult<BlogEntry> = new PagedResult<BlogEntry>();
		public pageIndex: number = 0;

		public async mounted() {
			this.loading = true;
			try {
				this.list = await this.$api.blogService.listEntries(this.pageIndex, 10);
			} catch (err) {
				this.errorHandler.handle(err, 'An error occurred while loading blog entries');
			} finally {
				this.loading = false;
			}
		}


	}

